<template>
  <div class="main-content-container container-fluid px-4">
    <div class="page-header row no-gutters py-4">
      <div class="col-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">QC \ <span class="ActiveURL"> Multiplier</span></span>
        <!-- <h3 class="page-title">upload Syncc data</h3> -->
      </div>
    </div>
    <d-card class="card-small mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">Upload Input data</h6>

      </d-card-header>
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-row>
            <d-col>
              <d-form id="pricing">
                <d-form-row>

                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">From Country *</label>
                    <div class="col-md-4">
                      <select class="form-control" v-model="Multiplier.DataModel.Data.FromCountry">
                    <option style="padding:50px" v-for="Dropdown in Multiplier.Masters.CountryMaster" :value="Dropdown" :key="Dropdown.ReferenceNo" >{{ Dropdown.FromCountry }}</option>
                    </select>
                    </div>
                 </d-col>

                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Upload Generic Input file *</label>
                    <div class="col-md-7" v-if="Multiplier.DataModel.UIData.UploadedDataCount == 0">   
                     <!-- <ejs-uploader ref="uploadObj" :uploading="importExcel"   id='Noonfileupload' name="UploadFiles"></ejs-uploader> -->
                         <div class="button_group">
                          <a href="javascript:;" class="button_s my_file el-button button_s el-button--primary el-button--small" >
                          
                          <input type="file" id="avatar" @change="importExcel" name="avatar">
                          </a>
                          <d-button type="button" id="submit" title="Please Select the panel" :disabled="(Multiplier.DataModel.Data.FromCountry ==null || Multiplier.DataModel.Data.GenericInputCount ==0 || Multiplier.DataModel.UIData.UploadedDataCount > 0 )" class="btn-accent" @click="getQuery" style="margin-right:10px" >upload Data</d-button>
                                <d-button type="button" id="submit" class="btn-accent" @click="ClearFileData">Cancel</d-button>
                          </div>
                    </div>
                     <div class="col-md-7" v-if="Multiplier.DataModel.UIData.UploadedDataCount > 0">  
                         <div class="SuccessLabel">
                           <span class="material-icons"> done_all </span> {{ Multiplier.DataModel.UIData.LoadedFileName }} file data uploaded Successfully 
                         </div>
                    </div>
                  </d-col>
                      <!-- 
                        <div class style="text-align:center">
                        <d-button type="button" id="submit" title="Please Select the panel" :disabled="( Multiplier.DataModel.Data.FromCountry ==null)" class="btn-accent" @click="MultiplierData" style="margin-right:10px" >upload Data</d-button>
                        <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                        </div>   -->

                 <d-col md="12" class="form-group row" v-if="(Multiplier.DataModel.UIData.UploadedDataCount > 0 && Multiplier.DataModel.Data.GenericInputCount > 0)">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from file</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{Multiplier.DataModel.Data.GenericInputCount}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row" v-if="Multiplier.DataModel.UIData.UploadedDataCount > 0">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds from table</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{Multiplier.DataModel.UIData.UploadedDataCount}}</label>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row"  v-if="Multiplier.DataModel.UIData.UploadedDataCount > 0">
                    <label class="col-md-3 col-form-label">Panel *</label>
                    <div class="col-md-4">
                      <select class="form-control" @change="panelOnchange()" v-model="Multiplier.DataModel.Data.PanelInfo">
                    <option style="padding:50px" v-for="Dropdown in Multiplier.Masters.PanelList" :value="Dropdown"
                      :key="Dropdown.ReferenceNo" >{{ Dropdown.Name }}</option>
                    </select>
                    </div>
                 </d-col>

                 <d-col md="12" class="form-group row"  v-if="Multiplier.DataModel.UIData.UploadedDataCount > 0">
                    <label class="col-md-3 col-form-label">Country</label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{Multiplier.DataModel.Data.PanelInfo.Country}}</label>
                    </div>
                 </d-col>

                  <d-col md="12" class="form-group row" v-if="Multiplier.DataModel.UIData.Progressed > 0">
                    <label class="col-md-3 col-form-label">Total no. Of Recoreds Updated </label>
                    <div class="col-md-4">
                      <label class="col-md-5 col-form-label">{{Multiplier.DataModel.UIData.Progressed}}</label>
                    </div>
                 </d-col>

                  <d-col md="12" class="form-group row" v-if="Multiplier.DataModel.UIData.TemplateIsAvailable">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="Multiplier.DataModel.UIData.Template"  :name="Multiplier.DataModel.UIData.FileName"><span style="marige-top:10px;" > Download Data </span>   </download-excel>
                    </d-button>
                    </div>
                  </d-col>


                  <d-col md="12" class="form-group row"  v-if="Multiplier.DataModel.UIData.GenericInputTemplateCount"  >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="Multiplier.DataModel.UIData.GenericInputTemplate"  :name="Multiplier.DataModel.UIData.FileName"><span style="marige-top:10px;" > Download Generic Data </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                  <d-col md="12" class="form-group row"  v-if="Multiplier.DataModel.UIData.STWTemplate.length>0">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="Multiplier.DataModel.UIData.STWTemplate"  name="FixedPriceTemplate"><span style="marige-top:10px;" > Download STW Fixed Prices Data </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                  <d-col md="12" class="form-group row"  v-if="Multiplier.DataModel.UIData.STWBaseTemplate.length>0">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="Multiplier.DataModel.UIData.STWBaseTemplate"  name="BasePriceTemplate"><span style="marige-top:10px;" > Download STW Base Prices Data </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>
                  
                  <d-col md="12" class="form-group row"  v-if="Multiplier.DataModel.UIData.STWInventoryTemplate.length>0">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="Multiplier.DataModel.UIData.STWInventoryTemplate"  name="InventoryTemplate"><span style="marige-top:10px;" > Download STW Inventory Data </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>


                <d-col md="12" class="form-group row"  v-if="Multiplier.DataModel.UIData.TemplateIsAvailable" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="Multiplier.DataModel.UIData.AvailablityList"  :name="Multiplier.DataModel.UIData.AvailabilityTemplateFileName"><span style="marige-top:10px;" > Download Availability Template </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>
                <d-col md="12" class="form-group row"  v-if="Multiplier.DataModel.UIData.TemplateIsAvailable" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="Multiplier.DataModel.UIData.minMaxList"  :name="Multiplier.DataModel.UIData.MinMaxFileName"><span style="marige-top:10px;" > Download Price min & max Template </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>
          <d-col md="12" class="form-group row"  v-if="Multiplier.DataModel.UIData.RejectedList.length" >
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-7">
                    <d-button type="button" class="btn-accent" > 
                    <download-excel :data="Multiplier.DataModel.UIData.RejectedList"  name="RejectedList"><span style="marige-top:10px;" > Download Rejected List </span> </download-excel>
                    </d-button>
                    </div>
                  </d-col>

                                   
                  

                  <!--  
                  <d-col md="12" class="form-group row">
                    <label class="col-md-3 col-form-label">Upload Amazon File</label>
                    <div class="col-md-7">
                     <ejs-uploader ref="uploadObj" id='Amazonfileupload' name="UploadFiles"></ejs-uploader>
                    </div>
                  </d-col> -->

                </d-form-row>
                 <!-- <d-button type="button" id="submit" class="btn-accent" @click="getQuery">run</d-button> -->
                <br />
                <div class style="text-align:center"  v-if="Multiplier.DataModel.UIData.UploadedDataCount >0 && Multiplier.DataModel.UIData.IsSTWRequest==false">
                  <d-button type="button" id="submit" title="Please Select the panel" :disabled="(Multiplier.DataModel.Data.PanelInfo.Country == null || Multiplier.DataModel.Data.FromCountry ==null || Multiplier.DataModel.UIData.TemplateIsAvailable)" class="btn-accent" @click="GetList" style="margin-right:10px" >Submit</d-button>
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>
                <div class style="text-align:center"  v-if="Multiplier.DataModel.UIData.IsSTWRequest==true">
                  <!-- <d-button type="button" id="submit" title="Please Select the panel" v-if="Multiplier.DataModel.UIData.Progressed == 0"  :disabled="(Multiplier.DataModel.UIData.GenericInputTemplateCount==0)" class="btn-accent" @click="UpdateSTWPricing" style="margin-right:10px" >Update STW</d-button> -->
                  <d-button type="button" id="submit" class="btn-accent" @click="ClearUsersetup">Cancel</d-button>
                </div>


              </d-form>
            </d-col>
          </d-row>
        </d-list-group-item>
      </d-list-group>
    </d-card>
    <div v-if="Multiplier.PageLoad" class="load-container load1"><div class="loader">Loading...</div></div>
  </div>
</template>
<script>
import Utilities from "@/Utilities/Utilities";
import axios from "axios";
import xlsx from "xlsx";
import XLSX from 'xlsx';
export default {
  name: 'Multiplier',
   data() {
    return {
      Multiplier: {
        PageType: "Master",
        PageLoad: false, 
        DataModel: {
          Data: {
             QueryString:null,
            PanelInfo:{
              Name:null,
              Country:null
            },
            FromCountry:null,
            GenericInputCount:[],
            Token:null,
            Curd:null,
            CreatedBy:0,
            
          },
          UIData: {
            mySteps:['Step 1', 'Step 2', 'Step 3'],
            IsSTWRequest:false,
            currentStep:0,
            Template:[],
            minMaxList:[],
            ScrapInfo:[],
            Progressed:0,
            GenericInputTemplate:[],
            STWTemplate:[],
            STWInventoryTemplate:[],
            STWBaseTemplate:[],
            RejectedList:[],
            AvailablityList:[],
            GenericInputTemplateCount:0,
            TemplateIsAvailable :false,
            FileName:"Template",
            LoadedFileName:"",
            AvailabilityFileName:"Template",
            UploadedDataCount:0
          },
        },
        SessionInfo: {
          PageInfo: {
            userId: 0,
          },
        },
        ErrorInfo: [
          {
            ErrorID: 1,
            ErrorName: "",
            ErrorMessage: "",
          },
        ],

        Masters: {
          CountryMaster:[],
          PanelList:[
            {
              Name : "Amazon UAEDirect",
              Country:"UAEDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon India",
              Country:"India",
              Panel:"Amazon"
            },
            {
              Name : "Amazon IndiaDirect",
              Country:"IndiaDirect",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Australia",
              Country:"Australia",
              Panel:"Amazon"
            },
            {
              Name : "Amazon UAE",
              Country:"UAE",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Mexico",
              Country:"Mexico",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Canada",
              Country:"Canada",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Brazil",
              Country:"Brazil",
              Panel:"Amazon"
            },
            {
              Name : "Amazon Singapore",
              Country:"Singapore",
              Panel:"Amazon"
            },
            {
              Name : "Amazon KSA",
              Country:"KSA",
              Panel:"Amazon"
            },
            {
              Name : "Jokoka",
              Country:"UAE",
               Panel:"Jokoka"
            },
            {
              Name : "StoreUS",
              Country:"UAE",
               Panel:"StoreUS"
            },
            {
              Name : "Noon UAE",
              Country:"UAE",
              Panel:"Noon"
            },
            {
              Name : "Noon KSA",
              Country:"KSA",
              Panel:"Noon"
            },       
                           {
              Name : "LAZADA Singapore",
              Country:"Singapore",
              Panel:"LAZADA"
            },  
                  {
              Name : "SHOPEE Singapore",
              Country:"Singapore",
              Panel:"SHOPEE"
            },     
            {
              Name : "STW Australia",
              Country:"Australia",
			        Panel: "STW"
		        },
            {
              Name : "STW Brazil",
              Country:"Brazil",
              Panel: "STW"
            },
            {
              Name : "STW Canada",
              Country:"Canada",
              Panel: "STW"
            },
            {
              Name : "STW EU",
              Country:"EU",
              Panel: "STW"
            },
            {
              Name : "STW GBR",
              Country:"GBR",
              Panel: "STW"
            },
            {
              Name : "STW India",
              Country:"India",
              Panel: "STW"
            },
            {
              Name : "STW KSA",
              Country:"KSA",
              Panel: "STW"
            },
            {
              Name : "STW Mexico",
              Country:"Mexico",
              Panel: "STW"
            },
            {
              Name : "STW UAE",
              Country:"UAE",
              Panel: "STW"
            },
            {
              Name : "STW All Country",
              Country:"All_Country",
              Panel:"STW_All"
            }

          ]
        },
      },
    };
  },

  mounted(){
      this.Multiplier.SessionInfo.PageInfo.userId = sessionStorage.getItem("UserId");
       this.Multiplier.DataModel.Data.CreatedBy = sessionStorage.getItem("UserId");
      this.ListAllFromCountry();
  },
  methods: {
ClearFileData(){
     this.Multiplier.DataModel.Data.FromCountry = null;
     document.getElementById("pricing").reset();
     this.Multiplier.DataModel.UIData.IsSTWRequest = false;
},

panelOnchange(){


            this.Multiplier.DataModel.UIData.Template=[];
            this.Multiplier.DataModel.UIData.TemplateIsAvailable = false;
},

ClearUsersetup(){
            this.Multiplier.DataModel.UIData.Template = [];
            this.Multiplier.DataModel.UIData.TemplateIsAvailable = false;
            this.Multiplier.DataModel.Data.GenericInputCount = 0;
            this.Multiplier.DataModel.UIData.UploadedDataCount = 0;
            this.Multiplier.DataModel.UIData.GenericInputTemplateCount=false;
            this.Multiplier.DataModel.UIData.STWTemplate=[];
            this.Multiplier.DataModel.UIData.STWBaseTemplate=[];
            this.Multiplier.DataModel.UIData.STWInventoryTemplate=[];
            this.Multiplier.DataModel.UIData.Progressed = 0;
            this.Multiplier.DataModel.UIData.RejectedList=[];
            this.Multiplier.DataModel.UIData.IsSTWRequest = false;
        this.Multiplier.DataModel.Data.PanelInfo ={
          Name : null,
              Country:null
        }
        this.Multiplier.DataModel.Data.FromCountry =null;
        this.Multiplier.DataModel.UIData.UploadedDataCount= 0;
         document.getElementById("pricing").reset();
      },

      ListAllFromCountry(){
      let vm = this;
      vm.Multiplier.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.Multiplier.DataModel.Data.Token = Token;
      this.Multiplier.DataModel.Data.CRUD = "ListAllFromCountry";
      var dataString = JSON.stringify(this.Multiplier.DataModel.Data);
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.Multiplier.PageLoad = false;
            vm.Multiplier.Masters.CountryMaster = response.data.Result;
          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.Multiplier.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },


getQuery()
{
        let vm = this;
      vm.Multiplier.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.Multiplier.DataModel.Data.Token = Token;
      this.Multiplier.DataModel.Data.CRUD = "UploadPricingQCMultiplier";
      var dataString = JSON.stringify(this.Multiplier.DataModel.Data);

      axios.post("APIScript/PHP/APIService/PricingQC/PricingQCService.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.Multiplier.PageLoad = false;
            vm.Multiplier.DataModel.UIData.UploadedDataCount= vm.Multiplier.DataModel.Data.GenericInputCount;

          } else {

          }
        })
        .catch(function (response) {
          console.log(response);
            vm.Multiplier.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

},



      GetList(){
      let vm = this;
      vm.Multiplier.PageLoad = true;
      var Token = sessionStorage.getItem("Token");
      this.Multiplier.DataModel.Data.Token = Token;
      
      this.Multiplier.DataModel.UIData.FileName = this.Multiplier.DataModel.Data.PanelInfo.Name + " " + Date.now();
      this.Multiplier.DataModel.UIData.AvailabilityFileName = this.Multiplier.DataModel.Data.PanelInfo.Name + "UnAvailability" + " " + Date.now();
      this.Multiplier.DataModel.UIData.AvailabilityTemplateFileName = this.Multiplier.DataModel.Data.PanelInfo.Name + "Availability" + " " + Date.now();
      this.Multiplier.DataModel.UIData.MinMaxFileName = this.Multiplier.DataModel.Data.PanelInfo.Name + "Min and Max Pricing" + " " + Date.now();
      this.Multiplier.DataModel.Data.CreatedBy = this.Multiplier.SessionInfo.PageInfo.userId;
      var ListParameter = Utilities.JsonCopy(this.Multiplier.DataModel.Data);

      ListParameter.GenericInputCount = [];
      var dataString = null;
        

        // ListParameter.CRUD = "GetVtexList";
        // dataString = JSON.stringify(ListParameter);
        // this.GetVtexList(dataString);
       if(this.Multiplier.DataModel.Data.PanelInfo.Panel == "STW_All")
       {
        ListParameter.CRUD = "ListAllCountryMultiplierPricingQC";
        console.log(ListParameter);
        dataString = JSON.stringify(ListParameter);
        this.GetGenericInputList(dataString);
       }
       else if(this.Multiplier.DataModel.Data.PanelInfo.Panel == "STW")
       {
        ListParameter.CRUD = "ListAllSTWMultiplierPricingQC";
        console.log(ListParameter);
        dataString = JSON.stringify(ListParameter);
        this.GetGenericInputList(dataString);
       }
       else
       {
        ListParameter.CRUD = "ListMultiplierPricingQC";
        dataString = JSON.stringify(ListParameter);
        this.GetGenericInputList(dataString);
       }
      },
      MultiplierData(){
      let vm = this;
      var Token = sessionStorage.getItem("Token");
      this.Multiplier.DataModel.Data.Token = Token;
      this.Multiplier.DataModel.Data.CRUD = "Create";
      this.Multiplier.DataModel.UIData.FileName = this.Multiplier.DataModel.Data.PanelInfo.Name + " " + Date.now();
      var dataString = JSON.stringify(this.Multiplier.DataModel.Data);
       vm.Multiplier.PageLoad = true;
       vm.Multiplier.DataModel.UIData.UploadedDataCount = 0;
      axios.post("APIScript/PHP/APIService/PricingQC/PricingQCService.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.Multiplier.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
              console.log(response.data.Result);  
            vm.Multiplier.DataModel.UIData.UploadedDataCount = response.data.Result;
            

          } else {
              console.log(response.data.ErrorInfo);
              vm.Multiplier.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);  
          vm.Multiplier.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });
      },



UpdateSTWPricing(){

// vm.Multiplier.DataModel.UIData.GenericInputTemplate
  this.UpdatePrice(this);
},

UpdatePrice : async (mythis) => {  
   let vm = mythis;
      var Token = sessionStorage.getItem("Token");
      mythis.Multiplier.DataModel.Data.Token = Token;
      mythis.Multiplier.DataModel.Data.CRUD = "ProductPricing";
      mythis.Multiplier.DataModel.UIData.UploadStatus = false;
      mythis.Multiplier.DataModel.UIData.RejectedList=[];
      mythis.Multiplier.DataModel.UIData.Progressed = 0;

      // this.Multiplier.DataModel.UIData.ScrapInfo
      console.log(mythis.Multiplier.DataModel.UIData.GenericInputTemplate);


      
      for (var i = 0; i < mythis.Multiplier.DataModel.UIData.GenericInputTemplate.length; i++) {


      //   var STWTemplate={
      //     SKUID	:mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].SkuId,
      //     TradePolicy	:1,
      //     PriceList :mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].UAE_Price,
      //     PriceMin :mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].UAE_Price,
      //     Quantity:1,	
      //     DateFrom:null,	
      //     DateTo:null
      //   } 
      //   mythis.Multiplier.DataModel.UIData.STWTemplate.push(Utilities.JsonCopy(STWTemplate));
      //  STWTemplate={
      //     SKUID	:mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].SkuId,
      //     TradePolicy	:2,
      //     PriceList :mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].USA_Price,
      //     PriceMin :mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].USA_Price,
      //     Quantity:1,	
      //     DateFrom:null,	
      //     DateTo:null
      //   } 
      //   mythis.Multiplier.DataModel.UIData.STWTemplate.push(Utilities.JsonCopy(STWTemplate));
      //  STWTemplate={
      //     SKUID	:mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].SkuId,
      //     TradePolicy	:3,
      //     PriceList :mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].India_Price,
      //     PriceMin :mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].India_Price,
      //     Quantity:1,	
      //     DateFrom:null,	
      //     DateTo:null
      //   } 
      //   mythis.Multiplier.DataModel.UIData.STWTemplate.push(Utilities.JsonCopy(STWTemplate));

        // STWBaseTemplate


        for (var j = 0; j < mythis.Multiplier.DataModel.UIData.ScrapInfo.length; j++){  
            if(mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].ASIN == mythis.Multiplier.DataModel.UIData.ScrapInfo[j].ASIN)
            {
              mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].USA_Quantity = mythis.Multiplier.DataModel.UIData.ScrapInfo[j].USA_Quantity;
              mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].India_Quantity = mythis.Multiplier.DataModel.UIData.ScrapInfo[j].India_Quantity;
              mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].UAE_Quantity = mythis.Multiplier.DataModel.UIData.ScrapInfo[j].UAE_Quantity;
            }
        }
      }

      console.log(mythis.Multiplier.DataModel.UIData.STWTemplate);
 
      for (var i = 0; i < mythis.Multiplier.DataModel.UIData.GenericInputTemplate.length; i++) {

          // mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i]
          var PriceInfo={
            ASIN:mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].ASIN,
            SKUId:mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].SkuId,
            markup: 5,
            basePrice: Number(mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].UAE_Price),
            listPrice: Number(mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].UAE_Price),
             StockInHand: [
         {
            unlimitedQuantity: false,
            dateUtcOnBalanceSystem: null,
            WarehouseId:"1f83153",
            SKUId:mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].SkuId,
            quantity: Number(mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].UAE_Quantity),
          },
          {
            unlimitedQuantity: false,
            dateUtcOnBalanceSystem: null,
            WarehouseId:"1_1",
            SKUId:mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].SkuId,
            quantity: Number(mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].USA_Quantity),
         },
         {
            unlimitedQuantity: false,
            dateUtcOnBalanceSystem: null,
            WarehouseId:"1f1d410",
            SKUId:mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].SkuId,
            quantity: Number(mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].India_Quantity),
         } 
         ],
            fixedPrices: [
           {

            tradePolicyId: "1",
            value: Number(mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].UAE_Price),
            listPrice: 1,
            minQuantity: 1
          },
          {
            tradePolicyId: "2",
            value: Number(mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].KSA_Price),
            listPrice: 1,
            minQuantity: 1
         },
         {
            tradePolicyId: "3",
            value: Number(mythis.Multiplier.DataModel.UIData.GenericInputTemplate[i].India_Price),
            listPrice: 1,
            minQuantity: 1
        } 
        ]
        }
          console.log(PriceInfo);
          vm.Multiplier.DataModel.Data.ProductPricing = Utilities.JsonCopy(PriceInfo);
          var dataString = JSON.stringify(vm.Multiplier.DataModel.Data);
          vm.Multiplier.PageLoad = true;
          vm.Multiplier.DataModel.UIData.RejectedFileName = "RejectedList" + " " + Date.now();
        try {
          let response = await axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString);
             if (response.data.ErrorInfo == null) {
               mythis.Multiplier.PageLoad = false;
               if(response.data.Result.code == undefined)
               {
                  var objFailed ={
                    Asin:vm.Multiplier.DataModel.Data.ProductPricing.ASIN,
                    Error:response.data.Result
                  }
                  mythis.Multiplier.DataModel.UIData.RejectedList.push(Utilities.JsonCopy(objFailed));
               }
               else
               {
                 mythis.Multiplier.DataModel.UIData.Progressed+=1;
               }
          } else {
              console.log(response.data.ErrorInfo);
              mythis.Multiplier.PageLoad = false;
          }
        } catch (error) {
          console.log(error);
          mythis.Multiplier.PageLoad = false;
        }
       }
},
      

  // UploadedDataCount
  

      GetGenericInputList(dataString){
       let vm = this;
      axios.post("APIScript/PHP/APIService/PricingQC/PricingQCService.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.Multiplier.PageLoad = false;
            vm.$toaster.success("Successfully Generated.");
            vm.Multiplier.DataModel.UIData.GenericInputTemplate= response.data.Result;
            if(vm.Multiplier.DataModel.Data.PanelInfo.Name == "STW All Country")
          {
                 for (var i = 0; i < vm.Multiplier.DataModel.UIData.GenericInputTemplate.length; i++) {

                    var STWTemplate={
                      SKUID	:vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].SkuId,
                      TradePolicy	:1,
                      PriceList :vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].UAE_Price,
                      PriceMin :vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].UAE_Price,
                      Quantity:1,	
                      DateFrom:null,	
                      DateTo:null
                    } 
                    vm.Multiplier.DataModel.UIData.STWTemplate.push(Utilities.JsonCopy(STWTemplate));
                  STWTemplate={
                      SKUID	:vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].SkuId,
                      TradePolicy	:2,
                      PriceList :vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].KSA_Price,
                      PriceMin :vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].KSA_Price,
                      Quantity:1,	
                      DateFrom:null,	
                      DateTo:null
                    } 
                    vm.Multiplier.DataModel.UIData.STWTemplate.push(Utilities.JsonCopy(STWTemplate));
                  STWTemplate={
                      SKUID	:vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].SkuId,
                      TradePolicy	:3,
                      PriceList :vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].India_Price,
                      PriceMin :vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].India_Price,
                      Quantity:1,	
                      DateFrom:null,	
                      DateTo:null
                    } 
                    vm.Multiplier.DataModel.UIData.STWTemplate.push(Utilities.JsonCopy(STWTemplate));

                  var BaseTemplate={
                      // ProductId:vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].ProductId,
                      SKUID	:vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].SkuId,
                      CostPrice :vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].UAE_Price,
                      BasePrice :vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].UAE_Price,
                      ListPrice :vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].UAE_Price
                    } 
                    vm.Multiplier.DataModel.UIData.STWBaseTemplate.push(Utilities.JsonCopy(BaseTemplate));

                    var InventoryTemplate={
                      SkuId		:vm.Multiplier.DataModel.UIData.GenericInputTemplate[i].SkuId,
                      TotalQuantity:5,
                      ReservedQuantity:0,
                      AvailableQuantity:5,
                      WarehouseId: "1_1",
                      WarehouseName:"Warehouse - USA",
                      RefId:null,
                      IsActive :true,
                      UnlimitedQuantity:false,
                      LockIds: null,
                      } 
                       vm.Multiplier.DataModel.UIData.STWInventoryTemplate.push(Utilities.JsonCopy(InventoryTemplate));
      }
   }

            if(vm.Multiplier.DataModel.UIData.GenericInputTemplate.length > 0)
            {
                vm.Multiplier.DataModel.UIData.GenericInputTemplateCount = true;
                vm.Multiplier.DataModel.UIData.IsSTWRequest=true;
            }

                // vm.Multiplier.DataModel.UIData.GenericInputTemplate 

          } else {
              console.log(response.data.ErrorInfo);
                vm.Multiplier.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Data !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.Multiplier.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },

  
    AmazonTemplate(dataString){
       let vm = this;
        vm.Multiplier.DataModel.Data.CRUD = "GetAmazonList";
      axios.post("APIScript/PHP/APIService/SynccentricScrap/SynccentricScrap.php",dataString)
        .then(function (response) {
          if (response.data.ErrorInfo == null) {
            vm.Multiplier.PageLoad = false;
            vm.$toaster.success("Save Successfully.");
            // console.log(response.data.Result);

            response.data.Result.map(function(key,value){

                key.minimum_Buybox_seller_allowed_price=Math.ceil(key.price - ((10/100) * key.price));	
                key.maximum_Buybox_seller_allowed_price=Math.ceil(Number((10/100) * key.price) + Number(key.price));
                // key.
            });

            vm.Multiplier.DataModel.UIData.Template = response.data.Result;
            
            if(vm.Multiplier.DataModel.UIData.Template.length > 0)
            vm.Multiplier.DataModel.UIData.TemplateIsAvailable = true;
          } else {
              console.log(response.data.ErrorInfo);
                vm.Multiplier.PageLoad = false;
              vm.$swal.fire("Oops...", "Incorrect Mobile No, Date or Amount !","error");
          }
        })
        .catch(function (response) {
          console.log(response);
            vm.Multiplier.PageLoad = false;
          vm.$swal.fire("Oops", "Something went worng", "error");
        });

    },


    getHeader(sheet) {
      const XLSX = xlsx;
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]); // worksheet['!ref'] Is the valid range of the worksheet
      let C;
      /* Get cell value start in the first row */
      const R = range.s.r; //Line / / column C
      let i = 0;
      for (C = range.s.c; C <= range.e.c; ++C) {
        var cell =
          sheet[
            XLSX.utils.encode_cell({ c: C, r: R })
          ]; /* Get the cell value based on the address  find the cell in the first row */
        var hdr = "UNKNOWN" + C; // replace with your desired default
        // XLSX.utils.format_cell Generate cell text value
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        if(hdr.indexOf('UNKNOWN') > -1){
          if(!i) {
            hdr = '__EMPTY';
          }else {
            hdr = '__EMPTY_' + i;
          }
          i++;
        }
        headers.push(hdr);
      }
      return headers;
    },
    /**
     * Import table
     */
     importExcel(e) {

      const files = e.target.files;
      this.Multiplier.PageLoad = true;
      this.Multiplier.DataModel.UIData.LoadedFileName = files[0].name;
      if (!files.length) {
        return ;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.Multiplier.PageLoad = false;
        return alert("The upload format is incorrect. Please upload xls or xlsx format");
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          console.log(ev);
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the dat   a of the first sheet
          const excellist = []; // Clear received data
          // Edit data

          // var loopCount =  ws.length/20000

          this.Multiplier.DataModel.UIData.ScrapInfo=[];
          this.Multiplier.DataModel.Data.GenericInputCount = 0 ;
          this.Multiplier.DataModel.Data.QueryString = "INSERT INTO `MultiplierPricingACTemp` (`Asin`, `category`, `weight`, `country` ,`SellPrice`, `PurchasePrice`, `Buybox_seller`, `FromPanel`, `TradePolicy`, `CreatedBy`) VALUES";

          for (var i = 0; i < ws.length; i++) {

        var ScrabData={
              sku:null,
              price:null,
              ASIN:null,
              Country:null,
              PurchasePrice:null,
              Category:null,
              Weight:null,
              FromPanel:null,
              TradePolicy:null,
              Buybox_seller:null
            }


           if(ws[i].ASIN !=undefined)
            {
                ScrabData.ASIN = ws[i].ASIN;
            }
            else
            {
              ScrabData.ASIN = ws[i].sku.substring(10,ws[i].sku.length);
            }

            if(ws[i].sku !=undefined)
            {
                ScrabData.Category = ws[i].sku.substring(0, 3);
                ScrabData.Weight = ws[i].sku.substring(3, 5);
                ScrabData.FromPanel = ws[i].sku.substring(5, 10);

              
            }
            else
            {
              ScrabData.Category = 0;
              ScrabData.Weight =0;
              ScrabData.FromPanel=null;
            }

            if(ws[i].price !=undefined )
            {
                 ScrabData.price = ws[i].price;
            }
            else if(ws[i].PriceList !=undefined)
            {
                ScrabData.price = ws[i].PriceList;
            }
            else
            {
              ScrabData.price = 0;
            }

            if(ws[i].PurchasePrice !=undefined)
            {
                ScrabData.PurchasePrice = ws[i].PurchasePrice;
            }
            else
            {
              ScrabData.PurchasePrice = null;
            }

            if(ws[i].Buybox_seller !=undefined)
            {
                ScrabData.Buybox_seller = ws[i].Buybox_seller;
            }
            else
            {
              ScrabData.Buybox_seller = null;
            }


            if(ws[i].TradePolicy !=undefined)
            {
                ScrabData.TradePolicy = ws[i].TradePolicy;
            }
            else
            {
              ScrabData.TradePolicy = null;
            }

            // TradePolicy


             ScrabData.CreatedBy = this.Multiplier.SessionInfo.PageInfo.userId;

            this.Multiplier.DataModel.UIData.ScrapInfo.push(Utilities.JsonCopy(ScrabData));
                                                                                                                                                                                                                        
            this.Multiplier.DataModel.Data.QueryString = this.Multiplier.DataModel.Data.QueryString + "(\'" + ScrabData.ASIN + "\',\'" +ScrabData.Category + "\',\'" +ScrabData.Weight + "\',\'" + this.Multiplier.DataModel.Data.FromCountry.FromCountry + "\',\'" +ScrabData.price + "\',\'" +ScrabData.PurchasePrice + "\','" +ScrabData.Buybox_seller + "\',\'" +ScrabData.FromPanel + "\',\'" + ScrabData.TradePolicy + "\',\'" +this.Multiplier.DataModel.Data.CreatedBy + "\' )";

            if(i < (ws.length - 1))
            {
              this.Multiplier.DataModel.Data.QueryString = this.Multiplier.DataModel.Data.QueryString+"," 
            }
            this.Multiplier.DataModel.Data.GenericInputCount +=1;
            
            // this.Multiplier.DataModel.Data.GenericInputCount.push(ScrabData);
            //  excellist.push(ws[i]);
          }

          
           this.Multiplier.DataModel.Data.QueryString = this.Multiplier.DataModel.Data.QueryString+";"
          // console.log("Read results", this.Multiplier.DataModel.Data.GenericInputCount); // At this point, you get an array containing objects that need to be processed
          // Get header2-1
          const a = workbook.Sheets[workbook.SheetNames[0]];
          const headers = this.getHeader(a);
          console.log('headers', this.Multiplier.DataModel.Data.GenericInputCount);  
          this.Multiplier.PageLoad = false;
          //  console.log(this.Multiplier.DataModel.Data.QueryString); 
          // this.Multiplier.DataModel.Data.QueryString = JSON.stringify(this.Multiplier.DataModel.Data.QueryString); 
          // Get header2-2S
        } catch (e) {
          console.log(e); 
            this.Multiplier.PageLoad = false;
          return alert("Read failure!");;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      var input = document.getElementById("upload");
    },	

 previewFiles(e) {
          console.log("test");
          var files = e.target.files, f = files[0];
          var reader = new FileReader();
          reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, {type: 'array'});
            let sheetName = workbook.SheetNames[0]
            /* DO SOMETHING WITH workbook HERE */
            console.log(workbook);
            let worksheet = workbook.Sheets[sheetName];
            console.log(XLSX.utils.sheet_to_json(worksheet));
          };
          reader.readAsArrayBuffer(f);
       }
  }
}
</script>